import { useMutation } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { BookActivity } from "@modules/bookActivities/types";
import { BookActivityFormValues } from "@modules/bookActivities/validations";

import { editBookActivityService } from "./service";
import { UseEditBookActivityMutationOptions } from "./types";

export function useEditBookActivityMutation(
  options?: UseEditBookActivityMutationOptions
) {
  const { open } = useNotification();
  const translate = useTranslate();

  return useMutation<BookActivity, ApiError, { id: string; data: BookActivityFormValues }>({
    mutationFn: ({ id, data }) => editBookActivityService(id, data),
    onSuccess: () => {
      open?.({
        type: "success",
        message: translate("book_activity_admin.success.edit"),
      });
    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
